import { useNavigate } from "react-router-dom";

const navigation = {
  Fieldsathi: [
    { name: "About", href: "/about" },
    { name: "Features", href: "/features" },

    { name: "Pricing", href: "/pricing" },
    { name: "Contact", href: "/contact" },
  ],
  "Contact Info": [
    { name: "Secureventure Private Limited" },
    {
      name: "44L & 6L Lower Ground Floor, Tricity Plaza, Peer Muchalla, Zirakpur, Punjab 140603",
      href: "#",
    },
    { name: "sales@fieldsathi.com", href: "mailto:sales@fieldsathi.com" },
    { name: "support@fieldsathi.com", href: "mailto:support@fieldsathi.com" },
    { name: "77339-76339", href: "tel:77339-76339" },
  ],
  Features: [
    { name: "Location Tracking", href: "/features/location-tracking" },
    { name: "Attendance", href: "/features/attendance" },
    { name: "Task Management", href: "/features/task-management" },
    { name: "Expense Management", href: "/features/expense-management" },
    { name: "Order Management", href: "/features/order-management" },
    { name: "Target Management", href: "/features/target-management" },
  ],
  Legal: [
    { name: "Terms and Conditions", href: "/terms-conditions" },
    { name: "Privacy Policy", href: "/privacy-policy" },
  ],
};

export default function Footer() {
  const navigate = useNavigate();
  const handleNavigation = (href) => {
    navigate(href);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <footer
      className="w-100"
      style={{
        backgroundColor: "#0d47a1",
        color: "white",
        padding: "40px 0 10px",
      }}
    >
      <div className="container-fluid px-4 px-md-5">
        <div className="row">
          {Object.entries(navigation).map(([section, links]) => (
            <div
              className="col-md-3"
              key={section}
              style={{ marginBottom: "20px" }}
            >
              <h5 style={{ textTransform: "uppercase", marginBottom: "15px" }}>
                {section}
              </h5>
              <ul className="list-unstyled">
                {links.map((item) => (
                  <li key={item.name}>
                    <span
                      style={{
                        color: "white",
                        textDecoration: "none",
                        cursor: "pointer",
                      }}
                      onClick={() => handleNavigation(item.href)}
                    >
                      {item.name}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <div
        style={{
          textAlign: "center",
          borderTop: "1px solid gray",
          paddingTop: "10px",
          marginTop: "10px",
          paddingBottom: "0",
        }}
      >
        <p style={{ fontSize: "14px", marginBottom: "0" }}>
          &copy; {new Date().getFullYear()} Fieldsathi. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
